module.exports = __webpack_public_path__ + "static/media/dark-theme-stopped.5283da07.svg";